import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

import {ProfileOrderHistorySection} from './ProfileOrderHistorySection';

export default connect(
  createStructuredSelector({
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
  }),
)(ProfileOrderHistorySection);
